var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCafe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "cafe_svg__a",
    cx: 1.75,
    cy: 2.857,
    rx: 1.75,
    ry: 2.857
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "cafe_svg__c",
    cx: 1.167,
    cy: 2.143,
    rx: 1.167,
    ry: 2.143
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.36 2h7.28a1 1 0 01.954.702L17 4h0H7l.406-1.298A1 1 0 018.36 2z",
    stroke: "#666",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 5h12l-1.51 15.1a1 1 0 01-.995.9h-6.99a1 1 0 01-.995-.9L6 5h0z",
    stroke: "#666",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.72 4h12.56a1 1 0 01.948.684l.333 1A1 1 0 0118.613 7H5.387a1 1 0 01-.948-1.316l.333-1A1 1 0 015.721 4z",
    stroke: "#666",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(40 -5.786 22.454)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cafe_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cafe_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#cafe_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.802-.276C1.418.705.946 1.717 1.387 2.758c.66 1.562 1.634 2.557.22 4.385",
    stroke: "#666",
    strokeWidth: 0.6,
    mask: "url(#cafe_svg__b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(-1 1) rotate(40 -21.71 -8.2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cafe_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cafe_svg__c"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#cafe_svg__c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.868-.207C.945.529.63 1.288.925 2.069c.44 1.17 1.09 1.917.147 3.288",
    stroke: "#666",
    strokeWidth: 0.6,
    mask: "url(#cafe_svg__d)"
  })))));
}
export default SvgCafe;